import React, { Component } from "react";
import "./nav-link.css";


class NavLink extends Component {

  state = {
    hovered: false
  };

  hover = () => this.setState({ hovered: true });
  unhover = () => this.setState({ hovered: false });

  render() {
    const { name, handler, style, children, hoverColor } = this.props;
    return (
      <a
        className="nav_link"
        onClick={e => {
          e.preventDefault();
          handler();
        }}
        style={{
          ...style,
          color: this.state.hovered ? hoverColor : null
        }}
        onMouseEnter={this.hover}
        onMouseLeave={this.unhover}
      >
        {children}
        {
          name ?
            <div className="nav_link__name">
              {name}
            </div>
            :
            null
        }
      </a>
    )
  }
}


export default NavLink;



// WEBPACK FOOTER //
// ./src/components/nav-link/nav-link-component.js